import { render } from "./ModalPublish.vue?vue&type=template&id=106be092"
import script from "./ModalPublish.vue?vue&type=script&lang=js"
export * from "./ModalPublish.vue?vue&type=script&lang=js"
script.render = render

export default script